module.exports = ".container{padding:10px;background-color:#ecf0f1;border:1px solid #e4e3e3}\n"